import _ from 'lodash';

/**
 * Currency symbols for all currencies supported by Shopify
 * Reference: https://help.shopify.com/en/manual/payments/shopify-payments/multi-currency/setup
 */
const currencySymbols = {
  USD: '$',      // United States Dollar
  EUR: '€',      // Euro
  GBP: '£',      // British Pound
  CAD: 'CA$',    // Canadian Dollar
  AUD: 'A$',     // Australian Dollar
  JPY: '¥',      // Japanese Yen
  CHF: 'CHF',    // Swiss Franc
  HKD: 'HK$',    // Hong Kong Dollar
  NZD: 'NZ$',    // New Zealand Dollar
  SGD: 'S$',     // Singapore Dollar
  DKK: 'kr.',    // Danish Krone
  NOK: 'kr',     // Norwegian Krone
  SEK: 'kr',     // Swedish Krona
  MXN: 'MX$',    // Mexican Peso
  BRL: 'R$',     // Brazilian Real
  AED: 'AED',    // UAE Dirham
  AFN: '؋',      // Afghan Afghani
  ALL: 'L',      // Albanian Lek
  AMD: '֏',      // Armenian Dram
  ANG: 'ƒ',      // Netherlands Antillean Guilder
  AOA: 'Kz',     // Angolan Kwanza
  ARS: '$',      // Argentine Peso
  AWG: 'ƒ',      // Aruban Florin
  BBD: '$',      // Barbadian Dollar
  BDT: '৳',      // Bangladeshi Taka
  BGN: 'лв',     // Bulgarian Lev
  BMD: '$',      // Bermudian Dollar
  BND: '$',      // Brunei Dollar
  BOB: 'Bs.',    // Bolivian Boliviano
  BSD: '$',      // Bahamian Dollar
  BWP: 'P',      // Botswana Pula
  BZD: '$',      // Belize Dollar
  CLP: '$',      // Chilean Peso
  CNY: '¥',      // Chinese Yuan
  COP: '$',      // Colombian Peso
  CRC: '₡',      // Costa Rican Colón
  CZK: 'Kč',     // Czech Koruna
  DOP: 'RD$',    // Dominican Peso
  EGP: 'E£',     // Egyptian Pound
  FJD: 'FJ$',    // Fiji Dollar
  GHS: 'GH₵',    // Ghanaian Cedi
  GIP: '£',      // Gibraltar Pound
  GTQ: 'Q',      // Guatemalan Quetzal
  GYD: '$',      // Guyanese Dollar
  HUF: 'Ft',     // Hungarian Forint
  IDR: 'Rp',     // Indonesian Rupiah
  ILS: '₪',      // Israeli New Shekel
  INR: '₹',      // Indian Rupee
  ISK: 'kr',     // Icelandic Króna
  JMD: '$',      // Jamaican Dollar
  KES: 'KSh',    // Kenyan Shilling
  KRW: '₩',      // South Korean Won
  LKR: 'Rs',     // Sri Lankan Rupee
  MAD: 'MAD',    // Moroccan Dirham
  MMK: 'K',      // Myanmar Kyat
  MOP: 'MOP$',   // Macanese Pataca
  MUR: '₨',      // Mauritian Rupee
  MYR: 'RM',     // Malaysian Ringgit
  NGN: '₦',      // Nigerian Naira
  PHP: '₱',      // Philippine Peso
  PKR: '₨',      // Pakistani Rupee
  PLN: 'zł',     // Polish Złoty
  RON: 'lei',    // Romanian Leu
  RUB: '₽',      // Russian Ruble
  SAR: 'SAR',    // Saudi Riyal
  SRD: '$',      // Surinamese Dollar
  THB: '฿',      // Thai Baht
  TRY: '₺',      // Turkish Lira
  TTD: '$',      // Trinidad and Tobago Dollar
  TWD: 'NT$',    // New Taiwan Dollar
  TZS: 'TSh',    // Tanzanian Shilling
  UAH: '₴',      // Ukrainian Hryvnia
  UYU: '$',      // Uruguayan Peso
  VND: '₫',      // Vietnamese Dong
  XCD: '$',      // East Caribbean Dollar
  ZAR: 'R',      // South African Rand
};

/**
 * Returns the currency symbol for a given currency code
 * @param {string} code - The currency code (e.g., 'USD', 'EUR')
 * @returns {string} The currency symbol
 */
export function getCurrencySymbol(code) {
  return _.get(currencySymbols, code, "$");
} 